import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BiCalendar } from "react-icons/bi";
import {
  BsSearch,
  BsList,
  BsChatDots,
  BsBell,
  BsGear,
  BsPower,
} from "react-icons/bs";

import { useNavigate } from "react-router-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Sidebar from "./Sidemenu";

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/login");
  };

  return (
    <div className="container-fluid">
      <div className="d-flex">
        <Sidebar />
        <div style={{ width: "100%",height:'100vh',overflowY:'auto' }}>
          <div style={{marginTop:'100px'}}>

          {/* Second rectangular box */}
          <div
            className="d-flex mt-5 align-items-center justify-content-between bg-white"
            style={{
              height: "57px",
              paddingLeft: "15px",
            }}
          >
            {/* Small rectangular boxes inside the second rectangular box */}
            <div className="row w-100">
              <div className="col-md-2 flex-fill">
                <div
                  className="text-black border border-gray p-3 mb-3 align-self-start"
                  style={{ height: "100px", backgroundColor: "#FFECEC" }}
                >
                  Total no of campaigns
                  <div className="d-flex justify-content-between mt-2">
                    <div>500</div>
                    <div
                      className="rounded-circle overflow-hidden border mt-0  border-dark"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <img
                        src="images/email Campaign Icon.svg"
                        alt=""
                        className="img-fluid mt-1 ml-1"
                        style={{ width: "80%", height: "80%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 flex-fill">
                <div
                  className="text-black border border-light p-3 mb-4 align-self-start"
                  style={{ height: "100px", backgroundColor: "#F7ECFF" }}
                >
                  Opens
                  <div className="d-flex justify-content-between mt-2">
                    <div>100</div>
                    <div
                      className="rounded-circle overflow-hidden border mt-0  border-dark"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <img
                        src="images/Open Email.svg"
                        alt=""
                        className="img-fluid mt-1 ml-1"
                        style={{ width: "80%", height: "80%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 flex-fill">
                <div
                  className="text-black border border-gray p-3 mb-3 align-self-start"
                  style={{ height: "100px", backgroundColor: "#ECF0FF" }}
                >
                  Clicks
                  <div className="d-flex justify-content-between mt-2">
                    <div>100</div>
                    <div
                      className="rounded-circle overflow-hidden border mt-0  border-dark"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <img
                        src="images/Open Email.svg"
                        alt=""
                        className="img-fluid mt-1 ml-1"
                        style={{ width: "80%", height: "80%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 flex-fill">
                <div
                  className="text-black border border-gray p-3 mb-3 align-self-start"
                  style={{ height: "100px", backgroundColor: "#B7EEE4" }}
                >
                  Total Spam Reports
                  <div className="d-flex justify-content-between mt-2">
                    <div>100</div>
                    <div
                      className="rounded-circle overflow-hidden border mt-0  border-dark"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <img
                        src="images/Spam Email Icon.svg"
                        alt=""
                        className="img-fluid mt-1 ml-1"
                        style={{ width: "80%", height: "80%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 flex-fill">
                <div
                  className="text-black border border-gray p-3 mb-3 align-self-start"
                  style={{ height: "100px", backgroundColor: "#FAD7EA" }}
                >
                  Delivered Percentage
                  <div className="d-flex justify-content-between mt-2">
                    <div>65%</div>
                    <div
                      className="rounded-circle overflow-hidden border mt-0  border-dark"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <img
                        src="images/Open Email.svg"
                        alt=""
                        className="img-fluid mt-1 ml-1"
                        style={{ width: "80%", height: "80%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Third rectangular box */}
          <div
            className="d-flex mt-5 align-items-center justify-content-between bg-white"
            style={{
              height: "150px",
              paddingLeft: "15px",
              marginBottom: "16px",
            }}
          >
            {/* Small rectangular boxes inside the third rectangular box */}
            <div className="row w-100">
              <div className="col-md-2 flex-fill">
                <div
                  className="text-black w-4 mt-5 border border-gray p-3 mb-3 align-self-start"
                  style={{ height: "220px", backgroundColor: "white" }}
                >
                  {/* Campaign Performance */}
                  <h5>Campaign Performance</h5>

                  {/* Campaign Metrics Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "10px",
                      borderBottom: "1px solid lightgray",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ flex: 2 }}>Campaign Names</span>
                    <span style={{ flex: 1 }}>Impression</span>
                    <span style={{ flex: 1 }}>Session</span>
                    <span style={{ flex: 1 }}>Revenue</span>
                  </div>

                  {/* Example Data Rows */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "5px",
                      borderBottom: "1px solid lightgray",
                    }}
                  >
                    <span style={{ flex: 2 }}>Startup Spark Campaign</span>
                    <span style={{ flex: 1 }}>2000</span>
                    <span style={{ flex: 1 }}>1500</span>
                    <span style={{ flex: 1 }}>$9042.0</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "5px",
                      borderBottom: "1px solid lightgray",
                    }}
                  >
                    <span style={{ flex: 2 }}>Hopeful Hearts Campaign</span>
                    <span style={{ flex: 1 }}>2000</span>
                    <span style={{ flex: 1 }}>1500</span>
                    <span style={{ flex: 1 }}>$9642.0</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "5px",
                      borderBottom: "1px solid lightgray",
                    }}
                  >
                    <span style={{ flex: 2 }}>Knowledge Quest</span>
                    <span style={{ flex: 1 }}>1800</span>
                    <span style={{ flex: 1 }}>1200</span>
                    <span style={{ flex: 1 }}>$8000.0</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "5px",
                      borderBottom: "1px solid lightgray",
                    }}
                  >
                    <span style={{ flex: 2 }}>Community Connect</span>
                    <span style={{ flex: 1 }}>2500</span>
                    <span style={{ flex: 1 }}>1800</span>
                    <span style={{ flex: 1 }}>$12000.0</span>
                  </div>
                </div>
              </div>

              <div className="col-md-2 flex-fill">
                <div
                  className="text-black mt-5 border  border-gray p-3 mb-3 align-self-start"
                  style={{ height: "240px", backgroundColor: "white" }}
                >
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={{
                      chart: {
                        type: "spline",
                        width: 700,
                        height: 220,
                      },
                      title: {
                        text: "Email Data Charts",
                        align: "left",
                      },
                      xAxis: {
                        categories: [
                          "2017",
                          "2018",
                          "2019",
                          "2020",
                          "2021",
                          "2022",
                          "2023",
                          "2024",
                        ],
                        crosshair: true,
                        accessibility: {
                          description: "Years",
                        },
                      },
                      yAxis: {
                        min: 0,
                        max: 100,
                        title: {
                          text: "Percentage",
                        },
                        tickInterval: 10, // Set the tick interval to 20 to create a gap
                        labels: {
                          formatter: function () {
                            return this.value + "%";
                          },
                        },
                      },
                      tooltip: {
                        valueSuffix: "%",
                      },
                      plotOptions: {
                        spline: {
                          marker: {
                            enabled: false,
                          },
                        },
                      },
                      series: [
                        {
                          name: "Click Through Rate",
                          data: [20, 25, 40, 60, 70, 60, 40, 30, 25, 30],
                          color: "darkblue",
                          type: "spline",
                        },
                        {
                          name: "Open Rate",
                          data: [80, 60, 40, 20, 10, 20, 40, 60, 70, 80],
                          color: "gray",
                          type: "spline",
                        },
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Gap */}
          <div style={{ height: "30px" }}></div>

          {/* New rectangle */}
          <div
            className="d-flex mt-5 align-items-center justify-content-between bg-white"
            style={{
              height: "150px",
              paddingLeft: "15px",
              marginBottom: "16px",
            }}
          >
            {/* Small rectangular boxes inside the new rectangular box */}
            <div className="row w-100">
              <div className="col-md-6 flex-fill">
                <div
                  className="text-black w-100 mt-5 border border-gray mb-1 p-3 align-self-start"
                  style={{ height: "250px", backgroundColor: "white" }}
                >
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={{
                      chart: {
                        type: "column",
                        width: 700,
                        height: 230,
                      },
                      title: {
                        text: "Email Traffic By Day of the Week",
                        align: "left",
                      },
                      xAxis: {
                        categories: [
                          "Sun",
                          "Mon",
                          "Tue",
                          "Wed",
                          "Thu",
                          "Fri",
                          "Sat",
                        ],
                        crosshair: true,
                        accessibility: {
                          description: "Days of the Week",
                        },
                      },
                      yAxis: {
                        min: 0,
                        max: 800,
                        title: {
                          text: "Count",
                        },
                        tickPositions: [0, 200, 400, 600, 800],
                      },
                      tooltip: {
                        valueSuffix: " mails",
                      },
                      plotOptions: {
                        column: {
                          pointPadding: 0.2,
                          borderWidth: 0,
                        },
                      },
                      series: [
                        {
                          name: "Received Mail",
                          data: [200, 400, 600, 800, 400, 200, 600],
                          color: "darkblue",
                        },
                        {
                          name: "Sent Mail",
                          data: [600, 800, 200, 400, 600, 200, 400],
                          color: "lightblue",
                        },
                      ],
                    }}
                  />
                </div>
              </div>

              <div className="col-md-4 flex-fill">
                <div
                  className="text-black w-100 mt-5 border border-gray  p-3 mb-3 align-self-start"
                  style={{ height: "220px", backgroundColor: "white" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={{
                        chart: {
                          type: "pie",
                          width: 350, // Adjusted width
                          height: 200,
                          marginLeft: -30, // Adjusted marginLeft
                        },
                        title: {
                          text: "Device Usage Distribution",
                          align: "left",
                          style: {
                            fontSize: "14px",
                            fontWeight: "bold",
                          },
                        },
                        tooltip: {
                          pointFormat:
                            "{series.name}: <b>{point.percentage:.1f}%</b>",
                        },
                        plotOptions: {
                          pie: {
                            innerSize: "50%",
                            allowPointSelect: true,
                            cursor: "pointer",
                            dataLabels: {
                              enabled: false,
                            },
                            showInLegend: false,
                          },
                        },
                        series: [
                          {
                            name: "Devices",
                            colorByPoint: true,
                            borderWidth: 2,
                            borderColor: "white",
                            data: [
                              {
                                name: "Mobile Devices",
                                y: 45,
                                color: "darkblue",
                              },
                              {
                                name: "iPad Devices",
                                y: 25,
                                color: "orange",
                              },
                              {
                                name: "Desktop Devices",
                                y: 30,
                                color: "gray",
                              },
                            ],
                          },
                        ],
                      }}
                    />
                    <div
                      style={{
                        marginLeft: "5px",
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "14px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "5px",
                        }}
                      >
                        <div
                          style={{
                            width: "15px",
                            height: "15px",
                            backgroundColor: "darkblue",
                            marginRight: "5px",
                          }}
                        ></div>
                        <span>Mobile - 45%</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "5px",
                        }}
                      >
                        <div
                          style={{
                            width: "15px",
                            height: "15px",
                            backgroundColor: "orange",
                            marginRight: "5px",
                          }}
                        ></div>
                        <span>iPad - 25%</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            width: "15px",
                            height: "15px",
                            backgroundColor: "gray",
                            marginRight: "5px",
                          }}
                        ></div>
                        <span>Desktop - 30%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ height: "30px" }}></div>

          {/* Another new rectangle */}
          <div
            className="d-flex mt-5 align-items-center justify-content-between bg-white"
            style={{
              height: "150px",
              paddingLeft: "15px",
              marginBottom: "16px",
            }}
          >
            {/* Small rectangular boxes inside the new rectangular box */}
            <div className="row w-100">
              <div className="col-md-6 flex-fill">
                <div
                  className="text-black w-100 mt-5 border border-gray  p-3 mb-3 align-self-start"
                  style={{
                    height: "220px",
                    backgroundColor: "white",
                    position: "relative",
                  }}
                >
                  {/* All Email Performance */}
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      left: "5px",
                      backgroundColor: "blue",
                      color: "white",
                      padding: "5px",
                    }}
                  >
                    All Email Performance
                  </div>

                  {/* Table */}
                  <table
                    style={{
                      width: "100%",
                      marginTop: "40px",
                      marginLeft: "30px",
                    }}
                  >
                    {/* Table Header */}
                    <thead>
                      <tr>
                        <th>
                          <input type="checkbox" />
                        </th>{" "}
                        {/* Checkbox Column */}
                        <th>Email</th>
                        <th>Publish Date</th>
                        <th>Sent</th>
                        <th>Click-Through Rate</th>
                        <th>Delivered Rate</th>
                        <th>Unsubscribed Rate</th>
                        <th>Spam Report Rate</th>
                      </tr>
                    </thead>
                    {/* Table Body */}
                    <tbody>
                      {/* Row 1 */}
                      <tr>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td>Financial Services</td>
                        <td>25-Jan-2024</td>
                        <td>10</td>
                        <td>2.65%</td>
                        <td>100%</td>
                        <td>100%</td>
                        <td>100%</td> {/* You can add your data here */}
                      </tr>

                      {/* Row 2 */}
                      <tr>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td>Healthcare Services</td>
                        <td>25-Jan-2024</td>
                        <td>10</td>
                        <td>2.65%</td>
                        <td>100%</td>
                        <td>100%</td>
                        <td>100%</td>
                        <td></td> {/* You can add your data here */}
                      </tr>
                      {/* Row 3 */}
                      <tr>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td>IT/Software Services</td>
                        <td>25-Jan-2024</td>
                        <td>10</td>
                        <td>2.65%</td>
                        <td>100%</td>
                        <td>100%</td>
                        <td>100%</td> {/* You can add your data here */}
                      </tr>
                      {/* Add more rows as needed */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
